import { createApiClient, type TokenStorage } from '@sahaj/api-client';
import { SahajWebSocketClient } from '@sahaj/websocket';

const STORAGE_PREFIX = 'sahaj_auth_';

const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch {
      // ignore
    }
  },
  removeItem: (key: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch {
      // ignore
    }
  }
};

export const tokenStorage: TokenStorage = {
  getAccessToken: async () => safeLocalStorage.getItem(`${STORAGE_PREFIX}access_token`),
  getRefreshToken: async () => safeLocalStorage.getItem(`${STORAGE_PREFIX}refresh_token`),
  setAccessToken: async (token: string) => {
    safeLocalStorage.setItem(`${STORAGE_PREFIX}access_token`, token);
  },
  setRefreshToken: async (token: string) => {
    safeLocalStorage.setItem(`${STORAGE_PREFIX}refresh_token`, token);
  },
  clearTokens: async () => {
    safeLocalStorage.removeItem(`${STORAGE_PREFIX}access_token`);
    safeLocalStorage.removeItem(`${STORAGE_PREFIX}refresh_token`);
  }
};

export function getAuthToken(): string | null {
  return (
    safeLocalStorage.getItem(`${STORAGE_PREFIX}access_token`) ||
    safeLocalStorage.getItem('token') ||
    (typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage.getItem('token') : null)
  );
}

export const api = createApiClient({
  storage: tokenStorage
});

export const ws = new SahajWebSocketClient({
  getAccessToken: async () => (await tokenStorage.getAccessToken()) || ''
});
